import { DatePicker, Input } from 'antd'
import CIMSFormItem from '../../../../../../../../../../../components/CIMSFormItem'
import CIMSSelect from '../../../../../../../../../../../components/CIMSSelect'
import { useValidateWhitespaceProps } from '../../../../../../../../../../../components/CIMSTextArea/hooks/useValidateWhitespaceProps'
import { HelpMessage } from '../../../../../../../../../../../utils/constants'
import CIMSTextArea from '../../../../../../../../../../../components/CIMSTextArea'
import { EJReportType, EJStatus } from 'shared'
import { CommonEJFormItemsProps } from './types'
import { useEJReportsSelectOptionsContext } from '../../../../../EJReportsSelectOptionsContext'
import { useEffect, useState } from 'react'
import { DefaultOptionType } from 'antd/lib/select'
import { useWatch } from 'antd/lib/form/Form'
import { useDisabledOptions } from '../../../../../../../../../../../hooks/useDisabledOptions'

const Help = HelpMessage.EngineeringJudgements.EJLog

const CommonEJFormItems: React.VFC<CommonEJFormItemsProps> = ({
  statusId,
  editing,
  form,
  types,
  typeOptions,
}) => {
  const { optionsMap, selectProps } = useEJReportsSelectOptionsContext()
  const failureDescriptionWSProps = useValidateWhitespaceProps({
    label: 'Failure Description',
  })
  const justificationWSProps = useValidateWhitespaceProps({
    label: 'Justification',
  })
  const notesWSProps = useValidateWhitespaceProps({
    label: 'Notes',
  })
  const [closedDisabledOptions, { some: closedDisabled }] = useDisabledOptions({
    disabled: !!editing && statusId === EJStatus.Closed.id,
    reason: {
      why: 'invalid status',
      statusName: EJStatus.Closed.name,
    },
  })
  const [reportOptions, setReportOptions] = useState<
    DefaultOptionType[] | undefined
  >(undefined)
  const [initialized, setInitialized] = useState<boolean>(false)
  const typeIdWatch = useWatch('typeId', form)

  useEffect(() => {
    setReportOptions(
      optionsMap.get(
        EJReportType.fromId(
          types?.find(({ id }) => typeIdWatch === id)?.reportTypeId
        )?.classType
      )
    )
    if (initialized) {
      form.setFieldValue('reports', undefined)
      form.setFieldValue('manualReportId', undefined)
    } else if (!!typeIdWatch) setInitialized(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeIdWatch, optionsMap, types])

  return (
    <>
      <CIMSFormItem
        name="typeId"
        label="Type"
        disabled={closedDisabledOptions}
        requiredMessage="Please select a Type"
        help={Help.Type}
      >
        <CIMSSelect simple options={typeOptions} disabled={closedDisabled} />
      </CIMSFormItem>
      {!!reportOptions ? (
        <CIMSFormItem
          label="Reports"
          name="reports"
          disabled={closedDisabledOptions}
          help={Help.Reports}
        >
          <CIMSSelect
            {...selectProps}
            options={reportOptions}
            disabled={closedDisabled}
          />
        </CIMSFormItem>
      ) : (
        <CIMSFormItem
          label="Reports"
          name="manualReportId"
          disabled={closedDisabledOptions}
          help={Help.Reports}
        >
          <Input disabled={closedDisabled} />
        </CIMSFormItem>
      )}
      <CIMSFormItem
        name="failureDate"
        label="Failure Date"
        requiredMessage="Please select a Failure Date"
        disabled={closedDisabledOptions}
        help={Help.FailureDate}
      >
        <DatePicker allowClear disabled={closedDisabled} />
      </CIMSFormItem>
      <CIMSFormItem
        name="failureDescription"
        disabled={closedDisabledOptions}
        help={Help.FailureDescription}
        {...failureDescriptionWSProps}
      >
        <CIMSTextArea disabled={closedDisabled} />
      </CIMSFormItem>
      <CIMSFormItem
        name="justification"
        disabled={closedDisabledOptions}
        help={Help.Justification}
        {...justificationWSProps}
      >
        <CIMSTextArea disabled={closedDisabled} />
      </CIMSFormItem>
      <CIMSFormItem
        name="notes"
        disabled={closedDisabledOptions}
        help={Help.Notes}
        {...notesWSProps}
      >
        <CIMSTextArea disabled={closedDisabled} />
      </CIMSFormItem>
    </>
  )
}

export default CommonEJFormItems
